import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tasks: [],
  aiSuggestions: [],
  previousURL: null,
};

const taskSlice = createSlice({
  name: "tasks", // Keeping 'tasks' as the slice name
  
  initialState,
  
  reducers: {
    // Keep SET_TASKS for replacing the entire task list
    SET_TASKS: (state, action) => {
      state.tasks = action.payload;
    },
    ADD_TASK: (state, action) => {
      // Ensure new task includes all AI fields
      state.tasks.push({
        ...action.payload,
        predictedTime: action.payload.predictedTime || null,
        category: action.payload.category || 'other',
        sentimentScore: action.payload.sentimentScore || null,
        extractedEntities: action.payload.extractedEntities || null,
        // Add other AI-related fields here with default null/other
      });
    },
    REMOVE_TASK: (state, action) => {
      state.tasks = state.tasks.filter(task => task.id !== action.payload);
    },
    TOGGLE_COMPLETE: (state, action) => { //the dispatch call
      const index = state.tasks.findIndex(task => task.id === action.payload);
      if (index !== -1) {
        state.tasks[index].completed = !state.tasks[index].completed;
      }
    },
    SET_AI_SUGGESTIONS: (state, action) => {
      state.aiSuggestions = action.payload;
    },
    SET_PREVIOUS_URL: (state, action) => {
      state.previousURL = action.payload;
    },
    CLEAR_PREVIOUS_URL: (state) => {
      state.previousURL = null;
    },
  },
});

export const {
  SET_TASKS,
  ADD_TASK,
  REMOVE_TASK,
  TOGGLE_COMPLETE,
  SET_AI_SUGGESTIONS,
  SET_PREVIOUS_URL,
  CLEAR_PREVIOUS_URL
} = taskSlice.actions;

// Use this selector (selectAllTasks) to retrieve the tasks array from state
export const selectAllTasks = (state) => state.tasks.tasks; // Corrected path to state.tasks.tasks
export const selectAiSuggestions = (state) => state.tasks.aiSuggestions;
export const selectPreviousURL = (state) => state.tasks.previousURL;

export default taskSlice.reducer;
